// extracted by mini-css-extract-plugin
module.exports = {"className":"ps-AF_className__IMjUF"};